import util from "../util";
/**
 * 市町村とメッシュコード対応テーブル
 */
export default class cityMeshTable {
    /**
     * コンストラクタ
     */
    constructor() {
        this._table = {};
        //  CSVファイルの読込
        let file = util.getPath(dosya_1kmesh_env.cityMeshTable);
        let csv = getCsv(file);
        //  テーブルデータの生成
        this.createTable(csv);
    }
    /**
     * テーブルデータの作成
     * @param csv
     */
    createTable(csv) {
        for (let i = 0; i < csv.length; i++) {
            const row = csv[i];
            const city = row[0];
            const name = row[1];
            const mesh = row[2];
            let list;
            if (this._table[mesh]) {
                list = this._table[mesh];
            }
            else {
                list = new Array();
                this._table[mesh] = list;
            }
            list.push(name);
        }
    }
    /**
     * メッシュコードから市町村名を取得
     * @param mesh
     */
    GetCityName(mesh) {
        let result = "";
        if (this._table[mesh]) {
            const list = this._table[mesh];
            for (let i = 0; i < list.length; i++) {
                result = result + list[i] + (i + 1 < list.length ? "<br>" : "");
            }
        }
        return result;
    }
}
